// export const Url = "http://localhost:3000/";
export const Url = "https://backend.boost-iq.ai/";
